import AgoraRTC from 'agora-rtc-sdk-ng';
import logger from '@/modules/Logger';
import { buildJoinMeta, joinPrefix } from '@/modules/webrtc/joinLogUtils';

export default {
  // create microphone tracks, microphone is required on rtc, so show error to user
  async createMicrophoneTracks() {
    const meta = buildJoinMeta({ provider: 'agora', lessonId: this.lessonId });

    logger.info(
      `${joinPrefix('Agora')} Creating microphone track`,
      meta
    );

    try {
      this.localAudioTrack?.close();
      this.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
        microphoneId: this.constraints.microphoneId
      });
      this.localTracks.push(this.localAudioTrack);

      logger.info(
        `${joinPrefix('Agora')} Microphone track created`,
        meta
      );
    } catch (err) {
      logger.debug('[Agora] Unable to access the microphone track', {
        operation: 'webrtc:mic',
        err,
        event_type: 50,
        lesson_id: this.lessonId
      });

      logger.warn(
        `${joinPrefix('Agora')} Microphone track creation failed - ${err.message}`,
        meta
      );
    }
  }
};
